import { VuexModule, Module, Mutation, Action } from "vuex-class-modules";
import {
  MenuInterface,
  responseInterface,
  SubMenuDataInterface,
} from "@/types";
import api from "@/apiClient";

@Module
export default class MenuModule extends VuexModule {
  private menu: MenuInterface[] = [];
  private globalLoader = false;
  private errorMessage = "";

  @Action
  public async Load(lang: string): Promise<void> {
    this.setGlobalLoader(true);

    try {
      const response: responseInterface = await api.menu.fetch(lang);

      if (response.statusCode !== 200 || !Array.isArray(response.data)) {
        throw new Error("Invalid response");
      }

      const data = response.data as MenuInterface[];
      await this.LoadSubMenu(data);
    } catch (error) {
      console.error("Menu load error:", error);
      this.setErrorMessage("Failed to load menu.");
    } finally {
      this.setGlobalLoader(false);
    }
  }

  @Action
  private async LoadSubMenu(menu: MenuInterface[]): Promise<void> {
    try {
      const subMenu: SubMenuDataInterface = await api.menu.fetchSubMenu();
      this.setMenu({ menu, subMenu });
    } catch (error) {
      console.error("Submenu load error:", error);
      this.setErrorMessage("Failed to load submenu.");
    }
  }

  @Mutation
  private setMenu(payload: {
    menu: MenuInterface[];
    subMenu: SubMenuDataInterface;
  }): void {
    const { menu, subMenu } = payload;

    const enrichedMenu = menu.map((m) => {
      const children = subMenu[m.name as keyof SubMenuDataInterface];
      return children ? { ...m, child: children } : m;
    });

    this.menu = enrichedMenu;
  }

  @Mutation
  private setGlobalLoader(loader: boolean): void {
    this.globalLoader = loader;
  }

  @Mutation
  private setErrorMessage(message: string): void {
    this.errorMessage = message;
  }

  get getMenu(): MenuInterface[] {
    return this.menu;
  }

  get getGlobalLoader(): boolean {
    return this.globalLoader;
  }

  get getErrorMessage(): string {
    return this.errorMessage;
  }
}
